import { useNotification } from '../contexts/NotificationContext';

export const useNotifications = () => {
  const { showSuccess, showError, showWarning, showInfo } = useNotification();

  return {
    // Notificações de sucesso
    success: {
      login: () => showSuccess('Login realizado!', 'Bem-vindo de volta!'),
      logout: () => showSuccess('Logout realizado!', 'Até logo!'),
      postCreated: () => showSuccess('Post criado!', 'O post foi criado com sucesso.'),
      postUpdated: () => showSuccess('Post atualizado!', 'O post foi atualizado com sucesso.'),
      postDeleted: () => showSuccess('Post deletado!', 'O post foi removido com sucesso.'),
      contactSent: () => showSuccess('Mensagem enviada!', 'Entraremos em contato em breve.'),
      contactUpdated: () => showSuccess('Contato atualizado!', 'O contato foi atualizado com sucesso.'),
      contactDeleted: () => showSuccess('Contato deletado!', 'O contato foi removido com sucesso.'),
      userCreated: () => showSuccess('Usuário criado!', 'O usuário foi criado com sucesso.'),
      userUpdated: () => showSuccess('Usuário atualizado!', 'O usuário foi atualizado com sucesso.'),
      userDeleted: () => showSuccess('Usuário deletado!', 'O usuário foi removido com sucesso.'),
      passwordChanged: () => showSuccess('Senha alterada!', 'Sua senha foi alterada com sucesso.'),
      settingsUpdated: () => showSuccess('Configurações salvas!', 'As configurações foram atualizadas.'),
      emailSent: () => showSuccess('Email enviado!', 'Verifique sua caixa de entrada.'),
      newsletterSubscribed: () => showSuccess('Inscrição realizada!', 'Você foi inscrito na nossa newsletter.'),
      newsletterStatusUpdated: () => showSuccess('Status atualizado!', 'O status da inscrição foi alterado.'),
      newsletterDeleted: () => showSuccess('Inscrito removido!', 'O inscrito foi removido com sucesso.'),
      socialPostCreated: () => showSuccess('Post criado!', 'O post de redes sociais foi criado com sucesso.'),
      socialPostUpdated: () => showSuccess('Post atualizado!', 'O post de redes sociais foi atualizado com sucesso.'),
      socialPostDeleted: () => showSuccess('Post deletado!', 'O post de redes sociais foi removido com sucesso.'),
      socialPostPublished: () => showSuccess('Publicação concluída!', 'O post foi processado nos canais selecionados.'),
      clienteCreated: () => showSuccess('Cliente cadastrado!', 'O cliente foi cadastrado com sucesso.'),
      clienteUpdated: () => showSuccess('Cliente atualizado!', 'O cliente foi atualizado com sucesso.'),
      clienteDeleted: () => showSuccess('Cliente excluído!', 'O cliente foi removido com sucesso.'),
      vendaCreated: () => showSuccess('Venda registrada!', 'A venda e as parcelas foram registradas com sucesso.'),
      vendaUpdated: () => showSuccess('Venda atualizada!', 'A venda foi atualizada com sucesso.'),
      vendaDeleted: () => showSuccess('Venda excluída!', 'A venda foi removida com sucesso.'),
      pagamentoRegistrado: () => showSuccess('Pagamento registrado!', 'A parcela foi marcada como paga.'),
      pagamentoAtualizado: () => showSuccess('Parcela atualizada!', 'Os dados da parcela foram corrigidos com sucesso.'),
      pagamentoExcluido: () => showSuccess('Parcela excluída!', 'A parcela foi removida com sucesso.'),
      vendaRegenerada: () => showSuccess('Parcelas refeitas!', 'As parcelas da venda foram excluídas e recriadas.'),
    },

    // Notificações de erro
    error: {
      login: (message: string) => showError('Erro no login', message),
      logout: (message: string) => showError('Erro no logout', message),
      postCreate: (message: string) => showError('Erro ao criar post', message),
      postUpdate: (message: string) => showError('Erro ao atualizar post', message),
      postDelete: (message: string) => showError('Erro ao deletar post', message),
      contactSend: (message: string) => showError('Erro ao enviar mensagem', message),
      contactUpdate: (message: string) => showError('Erro ao atualizar contato', message),
      contactDelete: (message: string) => showError('Erro ao deletar contato', message),
      userCreate: (message: string) => showError('Erro ao criar usuário', message),
      userUpdate: (message: string) => showError('Erro ao atualizar usuário', message),
      userDelete: (message: string) => showError('Erro ao deletar usuário', message),
      passwordChange: (message: string) => showError('Erro ao alterar senha', message),
      settingsUpdate: (message: string) => showError('Erro ao salvar configurações', message),
      emailSend: (message: string) => showError('Erro ao enviar email', message),
      newsletterSubscribe: (message: string) => showError('Erro na inscrição', message),
      newsletterStatusUpdate: (message: string) => showError('Erro ao atualizar status', message),
      newsletterDelete: (message: string) => showError('Erro ao remover inscrito', message),
      newsletterLoad: (message: string) => showError('Erro ao carregar newsletter', message),
      socialPostCreate: (message: string) => showError('Erro ao criar post', message),
      socialPostUpdate: (message: string) => showError('Erro ao atualizar post', message),
      socialPostDelete: (message: string) => showError('Erro ao deletar post', message),
      socialPostGenerate: (message: string) => showError('Erro ao gerar conteúdo', message),
      socialPostImage: (message: string) => showError('Erro ao obter imagem', message),
      socialPostPublish: (message: string) => showError('Erro ao publicar', message),
      network: () => showError('Erro de conexão', 'Verifique sua conexão com a internet.'),
      unauthorized: () => showError('Acesso negado', 'Você não tem permissão para esta ação.'),
      notFound: () => showError('Não encontrado', 'O recurso solicitado não foi encontrado.'),
      clienteCreate: (message: string) => showError('Erro ao cadastrar cliente', message),
      clienteUpdate: (message: string) => showError('Erro ao atualizar cliente', message),
      clienteDelete: (message: string) => showError('Erro ao excluir cliente', message),
      vendaCreate: (message: string) => showError('Erro ao registrar venda', message),
      vendaUpdate: (message: string) => showError('Erro ao atualizar venda', message),
      vendaDelete: (message: string) => showError('Erro ao excluir venda', message),
      pagamentoAction: (message: string) => showError('Erro ao processar pagamento', message),
    },

    // Notificações de aviso
    warning: {
      validation: (message: string) => showWarning('Validação', message),
      incomplete: (message: string) => showWarning('Dados incompletos', message),
      unsaved: () => showWarning('Alterações não salvas', 'Você tem alterações não salvas.'),
      sessionExpired: () => showWarning('Sessão expirada', 'Faça login novamente.'),
    },

    // Notificações de informação
    info: {
      loading: (message: string) => showInfo('Carregando', message),
      processing: (message: string) => showInfo('Processando', message),
      saved: (message: string) => showInfo('Salvo', message),
      updated: (message: string) => showInfo('Atualizado', message),
    },

    // Métodos diretos
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};
